import { Moon, Sun } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import InterviewChat from "../components/InterviewChat";

export default function InterviewPage() {
  const { isDark, toggleTheme } = useTheme();

  const bg = isDark ? "#0a0a0f" : "#f8f9fc";
  const textPrimary = isDark ? "#ffffff" : "#0a0a0f";
  const textSecondary = isDark ? "rgba(255,255,255,0.6)" : "#64748b";
  const cardBg = isDark ? "rgba(255,255,255,0.05)" : "#ffffff";
  const cardBorder = isDark ? "1px solid rgba(255,255,255,0.08)" : "1px solid rgba(0,0,0,0.06)";
  const accent = "#1a1f5e";
  const accentLight = "#2d3494";

  const t = { textPrimary, textSecondary, accent: "#f97316", accentDark: "#ea6a08" };

  return (
    <div style={{ height: "100vh", background: bg, display: "flex", flexDirection: "column", padding: "20px 16px 16px" }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexShrink: 0, maxWidth: 720, width: "100%", alignSelf: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: `linear-gradient(135deg, ${accent}, ${accentLight})`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <span style={{ color: "white", fontWeight: "bold", fontSize: 14 }}>W</span>
          </div>
          <span style={{ fontSize: 16, fontWeight: 700, fontFamily: "'Plus Jakarta Sans', sans-serif", color: textPrimary }}>AI Mock Interview</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button
            onClick={toggleTheme}
            aria-label="Toggle theme"
            style={{ width: 32, height: 32, borderRadius: "50%", background: isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.05)", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: textSecondary }}
          >
            {isDark ? <Sun size={14} /> : <Moon size={14} />}
          </button>
          <button
            onClick={() => window.close()}
            data-testid="close-interview-tab"
            style={{ padding: "6px 16px", borderRadius: 8, border: `1px solid ${isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.1)"}`, background: "transparent", color: textSecondary, fontSize: 13, cursor: "pointer" }}
          >
            Close
          </button>
        </div>
      </div>

      {/* Chat card — fills remaining viewport height */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          width: "100%",
          maxWidth: 720,
          alignSelf: "center",
          background: cardBg,
          border: cardBorder,
          borderRadius: 16,
          boxShadow: isDark ? "none" : "0 4px 24px rgba(0,0,0,0.06)",
          padding: 24,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <InterviewChat
          jobId={null}
          isDark={isDark}
          t={t}
          fullHeight
          onComplete={() => window.close()}
        />
      </div>
    </div>
  );
}
